/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import companyServices from '../../../../redux/services/companyServices';

const useContact = (companyId, pedagogicData, setPedagogicData) => {
  const addContact = (form, setForm) => {
    const pedagogicDataObj = {
      name: form.name.toUpperCase(),
      firstname: form.firstname,
      phone: form.phone,
      email: form.mail,
    };

    const formArr = Object.values(pedagogicDataObj);
    let err = false;
    formArr.forEach((item) => {
      if (item.length === 0) {
        toastError('Valeur(s) manquante(s).');
        err = true;
      }
    });

    if (err) {
      return;
    }

    companyServices.updateCompanyPedagogicData(companyId, [...pedagogicData, pedagogicDataObj])
      .then((res) => {
        toastSuccess('Données pédagogiques mises à jour.');
        pedagogicDataObj._id = res.pedagogicData[res.pedagogicData.length - 1]._id;
        setPedagogicData([...pedagogicData, pedagogicDataObj]);
        setForm({
          name: '',
          firstname: '',
          phone: '',
          mail: '',
        });
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour des données pédagogiques.');
      });
  };

  const updateContact = (newPedagogicData) => {
    const newData = [...pedagogicData];
    newData.forEach((referentData) => {
      if (referentData._id === newPedagogicData._id) {
        referentData.name = newPedagogicData.name.toUpperCase();
        referentData.firstname = newPedagogicData.firstname;
        referentData.phone = newPedagogicData.phone;
        referentData.email = newPedagogicData.email;
      }
    });
    companyServices.updateCompanyPedagogicData(companyId, newData)
      .then(() => {
        toastSuccess('Données pédagogiques mises à jour.');
        setPedagogicData(newData);
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour des données pédagogiques.');
      });
  };

  const deleteContact = (_id) => {
    const res = [];
    pedagogicData.forEach((data) => {
      if (data._id !== _id) {
        res.push(data);
      }
    });
    companyServices.updateCompanyPedagogicData(companyId, res)
      .then((_res) => {
        toastSuccess('Données pédagogiques mises à jour.');
        setPedagogicData(_res.pedagogicData);
      })
      .catch(() => {
        toastError('Problème lors de la mise à jour des données pédagogiques.');
      });
  };

  return {
    addContact,
    updateContact,
    deleteContact,
  };
};

export default useContact;
